import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { reportsBottomNavigationOptions } from 'on_web/helpers/redirectHelper';
import AssessmentPage from 'on_web/components/shared/AssessmentPage/AssessmentPage';
import { dnaCtaIllustration } from 'on_web/assets/imageList';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'on_web/components/shared/Common/Button';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import { COOL_BLUE } from 'colours';

/**
 * Page displaying enterprise demo teaser. This is a temporary page used before we don't have DNA risk calculator ready for individual users.
 */
export default function ReportsEnterpiseDemo(props) {
  const { t } = useTranslation();
  const [isDesktop] = useCheckScreenSize();

  const useStyles = makeStyles(theme => ({
    title: {
      fontFamily: 'Museo-500',
      fontSize: 18,
      lineHeight: 1.19,
      color: '#2a343f',
      textTransform: 'uppercase',
      paddingTop: '20px',
      textAlign: 'center',
      paddingLeft: '20px',
    },

    textDesktop: {
      fontFamily: 'Museo-500',
      fontSize: 18,
      lineHeight: 1.19,
      color: '#2a343f',
    },

    textMobile: {
      fontFamily: 'Museo-500',
      fontSize: 15,
      lineHeight: 1.19,
      color: '#2a343f',
    },
  }));

  const classes = useStyles();
  const pageTile = t('reporting.myAssessment.dnaBasedAssessment');

  return (
    <AssessmentPage
      headerMenuText={pageTile}
      bottomMenuSelectedOptionCode={reportsBottomNavigationOptions.dnaRisk}
      desktopMenuIndex={2}
      secondaryHeader={true}
      hasShareAction
    >
      <Grid
        container
        direction={isDesktop ? 'row' : 'column'}
        style={{
          borderBottom: isDesktop ? '1px Solid #efefef' : 'none',
          paddingBottom: isDesktop ? '55px' : '0',
        }}
        justify="center"
      >
        {isDesktop && (
          <Grid item xs={12}>
            <Box
              className={classes.title}
              display={'block'}
              textAlign={'center'}
            >
              <p>{pageTile}</p>
            </Box>
          </Grid>
        )}
        <Grid item xs style={{ width: isDesktop ? '510px' : 'auto' }}>
          <Box display={'block'} textAlign={'center'}>
            <img
              src={dnaCtaIllustration}
              alt="DNA illustration"
              style={{ width: isDesktop ? '450px' : 'auto' }}
            />
          </Box>
        </Grid>
        <Grid item xs>
          <Box
            mx={'17px'}
            className={isDesktop ? classes.textDesktop : classes.textMobile}
            justify="center"
          >
            <p>
              At this time, SPARE’s DNA-based assessment is not available for
              individuals.
            </p>
            <p>
              <span style={{ color: COOL_BLUE }}>
                The enterprise (100+ person) version of SPARE includes DNA-based
                risk assessments for almost 50 additional risk factors
                associated with COVID-19 vulnerability and severity risk, as
                well as tools to help companies bring their employees safely
                back to work.
              </span>
            </p>
            <p>
              If you are a member of a company interested in our SPARE
              enterprise package, please feel free to have your HR manager or
              executives contact{' '}
              <a
                href="mailto:partnerships@lifenome.com"
                style={{ color: COOL_BLUE }}
              >
                partnerships@lifenome.com
              </a>{' '}
              or click on the button below to schedule an appointment with our
              sales team.
            </p>
          </Box>
          <Box
            justify="center"
            textAlign="center"
            style={{
              marginBottom: isDesktop ? '0' : '70px',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              backgroundGradient={'linear-gradient(to right, #194378, #30eaff)'}
              style={{
                paddingLeft: '25px',
                paddingRight: '25px',
                paddingTop: '10px',
                paddingBottom: '10px',
                textTransform: 'uppercase',
              }}
              onClick={() => {
                trackEvent(
                  'Reporting',
                  'Schedule enterprise demo click on DNA-Based Assessment'
                );
                window.open(
                  'https://lifenome.pipedrive.com/scheduler/KkEkRlSz/spare-demo',
                  '_blank'
                );
              }}
            >
              {'Schedule enterprise demo'}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </AssessmentPage>
  );
}
